import { useFetchEpisodeOverview } from 'client/hooks/episodes/useFetchEpisodeOverview';
import { useFetchPodcastMetadata } from 'client/hooks/podcast/usePodcastMetadata';
import { useFetchSpanStatus } from 'client/hooks/span/useSpanStatus';
import { useOptimizelyFeature } from 'client/hooks/useOptimizelyFeature';
import { useParams } from 'react-router-dom';

/**
 * enable waveform ad insertion if:
 *
 * - optimizely feature flag is enabled
 *   AND
 * - is studios creator
 *   OR
 * - is SPAN activated and episode is a video podcast
 */
function useWaveformAdInsertionEnabled() {
  const [isEnabled] = useOptimizelyFeature('waveform_ad_insertion');
  const { data = {} } = useFetchPodcastMetadata();
  const { isStudioCreator } = data;

  // activated span and episode is a video episode
  const { podcastEpisodeId: webEpisodeId } = useParams<{
    podcastEpisodeId: string;
  }>();
  const { episodeOverviewData } = useFetchEpisodeOverview({
    webEpisodeId,
  });
  const isVideoEpisode = Boolean(episodeOverviewData?.videoPodcastingEpisode);
  const { spanStatusData } = useFetchSpanStatus();
  const isSPANActivated =
    spanStatusData?.spanActivationLifeCycleState === 'activated';

  const isWaveformAdInsertionEnabled =
    isEnabled && (isStudioCreator || (isVideoEpisode && isSPANActivated));

  return {
    isWaveformAdInsertionEnabled,
  };
}

export { useWaveformAdInsertionEnabled };
